import { useLocation } from "react-router-dom";
import { Head } from "vite-react-ssg";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  robots?: string;
  ogType?: "website" | "article" | "product";
  ogImage?: string;
  canonicalPath?: string;
  jsonLd?: Record<string, any> | Record<string, any>[];
  /** Public Markdown equivalent, when one actually exists. */
  markdownPath?: string;
}

export function SEO({
  title,
  description,
  keywords,
  robots = "index, follow",
  ogType = "website",
  ogImage = "/favicon.svg",
  canonicalPath,
  jsonLd,
  markdownPath,
}: SEOProps) {
  const location = useLocation();

  const currentUrl = `https://gerdoo.cloud${canonicalPath || location.pathname}`;
  const baseKeywords = "گردو, گردو کلاد, Gerdoo, خدمات ابری, رایانش ابری, سکوی ابری, PaaS";
  const fullKeywords = keywords ? `${keywords}, ${baseKeywords}` : baseKeywords;
  const resolvedOgImage = ogImage.startsWith("http") ? ogImage : `https://gerdoo.cloud${ogImage}`;

  return (
    <Head>
      <title data-pagefind-meta="title">{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={fullKeywords} />
      <meta name="robots" content={robots} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={resolvedOgImage} />
      <meta property="og:site_name" content="گردو کلاد" />
      <meta property="og:locale" content="fa_IR" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={resolvedOgImage} />
      
      <link rel="canonical" href={currentUrl} />
      {markdownPath && (
        <link rel="alternate" type="text/markdown" title="نسخه متنی برای خوانش ماشینی" href={markdownPath} />
      )}
      
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Head>
  );
}
